import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { persistReducer, persistStore, createTransform } from "redux-persist";
import storage from "redux-persist/lib/storage";

// Import reducers
import { organizationReducer } from "./reducers/organizationReducer.js";
import { userReducer } from "./reducers/userReducer.js";
import { storeReducer } from "./reducers/storeReducer.js";
import { branchReducer } from "./reducers/branchReducer.js";
import { subcategoryReducer } from "./reducers/subcategoryReducer.js";
import { productReducer } from "./reducers/productReducer.js";
import { inventoryReducer } from "./reducers/inventoryReducer.js";
import { storeInventoryReducer } from "./reducers/storeInventoryReducer.js";
import { salesReducer } from "./reducers/saleReducer.js";
import { orderReducer } from "./reducers/orderReducer.js";
import { cartReducer } from "./reducers/cartReducer.js";
import { customerReducer } from "./reducers/customerReducer.js";
import { paymentReducer } from "./reducers/paymentReducer.js";
import { returnReducer } from "./reducers/returnReducer.js";
import { supplierReducer } from "./reducers/supplierReducer.js";
import { purchaseReducer } from "./reducers/purchaseReducer.js";
import { expenseReducer } from "./reducers/expenseReducer.js";
import { staffReducer } from "./reducers/staffReducer.js";
import { zReportReducer } from "./reducers/zReportReducer.js";
import { shiftReducer } from "./reducers/shiftReducer.js";
import { settingsReducer } from "./reducers/settingsReducer.js";
import { flexpaysaleReducer } from "./reducers/flexpaysaleReducer.js";


// Combine reducers
const rootReducer = combineReducers({
  organization: organizationReducer,
  user: userReducer,
  store: storeReducer,
  branch: branchReducer,
  subcategory: subcategoryReducer,
  product: productReducer,
  inventory: inventoryReducer,
  storeInventory: storeInventoryReducer,
  sale: salesReducer,
  order: orderReducer,
  cart: cartReducer,
  customer: customerReducer,
  payment: paymentReducer,
  return: returnReducer,
  supplier: supplierReducer,
  purchase: purchaseReducer,
  expense: expenseReducer,
  staff: staffReducer,
  zReport: zReportReducer,
  shift: shiftReducer,
  settings: settingsReducer,
  flexpaysale: flexpaysaleReducer,
});

// Persist configuration
const userTransform = createTransform(
  // transform state on its way to being serialized and persisted.
  (inboundState) => {
    return inboundState;
  },
  // transform state being rehydrated
  (outboundState) => {
    if (outboundState) {
      outboundState.isLoading = false; // Reset isLoading on rehydrate
    }
    return outboundState;
  },
  // define which reducers this transform gets called for.
  { whitelist: ['user'] }
);

const persistConfig = {
  key: "root",
  storage,
  whitelist: ["user", "settings"],
  transforms: [userTransform],
};

// Create persisted reducer
const persistedReducer = persistReducer(persistConfig, rootReducer);

// Create persisted reducer

const middleware = (getDefaultMiddleware) =>
  getDefaultMiddleware({
    immutableCheck: import.meta.env.MODE !== 'development',
    serializableCheck: false,
  });

// Create store
const store = configureStore({
  reducer: persistedReducer,
  middleware,
});

// Create persistor
const persistor = persistStore(store);

export { persistor, store };
